import io from 'socket.io-client';
import {ALLOW_DUPLICATE_EVENTS, STORED_TRACKER_EVENTS, CONSTANT, FETCH_TRACKER_EVENTS, HRMS_STATUS, ON_BOARDING, REGEX} from '../../common/constant';
import {Decryption, detectDevice, Encryption, isInApp, showToastSuccess} from 'ubs-framework/v2/common/function';
import {checkCookie, createCookie, deleteAllCookies, eraseCookie, getCookie} from 'ubs-framework/v2/common/cookie';
import axios from 'axios';
import {ERROR, SUCCESS} from "../../common/string";
import {ANNOUNCEMENT_API} from "../../app-hrms/announcement/announcement-api";
import {API} from "../../common/api";
import {IS_DEV} from 'ubs-framework/v2/common/constant';
import {planMerger} from 'ubs-framework/v2/common/convert';
import {sendMessageRNW} from "../../common/functions/common";
import { isDuplicateRequest } from './duplicateRequestTracker';
import {checkForFetching} from "./fetchTracker";
import { checkInStore } from './storeTracker';

let socket;

const api = axios.create();
api.defaults.baseURL = process.env.REACT_APP_HRMS_API_URL;


/**===================================================================
 Get all active socket event listener
 ===================================================================
 + Show all active socket listeners in array format
 */
export const getAllListeners = () => {
    const listeners = socket.listeners("response")
    const list = []
    listeners.forEach(e => {
        if (e.name) list.push(e.name)
    })
}

const prepareData = (event, data) => {
    console.log(`(((${event})))`, data);
    return Encryption({event, data});
};

/**
 * Sends data through the socket connection with validation and duplicate prevention
 * @param {string} en - Event name to emit
 * @param {object} data - Data payload to send with the event
 * @param {boolean} force - Flag to force send data bypassing validation checks
 *
 * Validates:
 * 1. Token matching between cookie and socket
 * 2. Socket authentication for non-auth events
 * 3. Prevents duplicate requests unless forced or allowed
 * 4. Checks if event is already being fetched
 *
 * If validations pass, emits the event with encrypted data
 * Otherwise reloads the page if token mismatch
 */
export const sendData = async(en, data, force) => {
    const matchToken = new URLSearchParams(socket?.io?.opts?.query);
    if (checkCookie('ubs_token') && getCookie('ubs_token') === matchToken.get('token')) {
        const events = ['authenticate', 'onboardingAuth'];
        if (!events.includes(en) && !socket?.isAuthenticated) return;
        // In certain cases, data may not be retrieved if the event is placed into the fetching list.
        // To handle such scenarios, we need to forcibly fetch the data while bypassing all checks,
        // including duplication prevention and ongoing fetch event validations.
        if(!force && !ALLOW_DUPLICATE_EVENTS?.includes(en)){
            if (isDuplicateRequest(en, data)) return
        }
        if(!force && FETCH_TRACKER_EVENTS.includes(en)) {
            if(checkForFetching(en, data)) return;
        }
        if(!force && STORED_TRACKER_EVENTS.includes(en)) {
            const result = await checkInStore(en, data);
            if (result) return
        }
        if (socket?.connected) socket.emit('request', prepareData(en, data));
    } else window.location.reload();
};

function roughSizeOfObject(object) {

    let objectList = [];

    let recurse = (value) => {
        let bytes = 0;

        if (typeof value === 'boolean') {
            bytes = 4;
        } else if (typeof value === 'string') {
            bytes = value.length * 2;
        } else if (typeof value === 'number') {
            bytes = 8;
        } else if
        (
            typeof value === 'object'
            && objectList.indexOf(value) === -1
        ) {
            objectList[objectList.length] = value;

            for (let i in value) {
                bytes += 8; // an assumed existence overhead
                bytes += recurse(value[i])
            }
        }

        return bytes;
    }

    return recurse(object);
}

const checkObjectId = (id) => id?.length === 24 && REGEX.OBJECT_ID.test(id)

const userData = {
    getIds: (object) => {
        const keys = ['createdBy', 'updatedBy', 'actionBy', 'user', 'userId', 'userInfo', 'assignTo']
        const userIds = [];
        let recurse = (value) => {
            if (typeof value === 'object') {
                for (let key in value) {
                    if (typeof value[key] === 'object') {
                        if (keys.includes(key) && (value[key]?.user || value[key]?._id) && checkObjectId(value[key])) {
                            userIds.push(value[key]?.user || value[key]?._id)
                        } else recurse(value[key])
                    } else if (typeof value[key] === 'string' && keys.includes(key) && checkObjectId(value[key])) {
                        userIds.push(value[key])
                    }
                }
            }
            return userIds
        }
        return recurse(object);
    },
    sendIds: (DISPATCH, ids) => {
        if (ids.length !== 0) DISPATCH({type: 'FIND_MASTER_DATA_LIST', payload: {findUserIdsList: [...new Set(ids)]}})
    }
}

export const socketConnect = (dispatch, history, next) => {
    /**===================================================================
     request response Size calculation
     ===================================================================
     + Total size will store in local storage
     */
    // if(!localStorage.getItem('size')) localStorage.setItem('size', '0')
    // let size = Number(localStorage.getItem('size') || 0)
    // window.addEventListener("beforeunload", () => {
    //     if(localStorage.getItem('size')) localStorage.setItem('size', size)
    //     else localStorage.setItem('size', '0')
    // });

    /**===================================================================
     Socket connection
     ===================================================================
     + Socket listeners
     */
    const url = !IS_DEV ? process.env.REACT_APP_HRMS_SOCKET_URL : process.env.REACT_APP_HRMS_SOCKET_URL
    socket = io.connect(`${url}?token=${getCookie('ubs_token')}&flag=HRMS&orgId=${window?.location?.pathname?.split('/')[1]}`, {
        "transports": ['websocket'],
        closeOnBeforeunload: false
    });
    socket.on('connect', () => {
        dispatch({type: 'SOCKET_CONNECTION', payload: socket.id});
        next(socket.connected);
    });
    socket.on('response', response => {
        // size += roughSizeOfObject(response)
        // getAllListeners()

        let res;
        if (typeof response === 'string') res = Decryption(response);
        else res = response;

        console.log(`%c${res?.message}| ${res?.code}| ${res?.event} ===>`, `font-weight: 500; font-size: 12px; color:  ${res?.code === 200 ? '#60b158' : '#ff6961'};`, res);
        if (res) {
            if (!res?.error) {
                if (res?.data?.error) {
                    // alert(res.data.error);
                } else {
                    const includesEvents = ['announcement'] // just give main word which include in all API in your module
                    const hasEvent = !!includesEvents.find(e => res.event.includes(e))
                    const ignored = ['hrms|employee|feedback|listComments', API.listComment]
                    if (hasEvent && !ignored.includes(res.event)) userData.sendIds(dispatch, userData.getIds(res.data))

                    switch (res.event) {
                        case 'onboardingAuth': {
                            socket.isAuthenticated = true
                            dispatch({type: 'ON_BOARDING_AUTHENTICATE', payload: res.data});
                            sendData('hrms|onboarding|masterData|read', {});
                            break;
                        }
                        case 'authenticate':
                            const planAccess = planMerger(res?.data?.planAccess, res?.data?.productAccess, res?.data?.isAdmin)
                            if (planAccess?.hrms?.default?.access) {
                                if (!!res.data.orgId) {
                                    const orgId = window.location.pathname.split('/');
                                    if ((orgId[1] && orgId[1] !== res.data.orgId) || !orgId[2] || (orgId[2] && orgId[2].length === 0)) {
                                        history.push(`/${res.data.orgId}/${ON_BOARDING ? 'on-boarding' : 'dashboard'}`);
                                    }

                                    socket.isAuthenticated = true
                                    sendMessageRNW(1, {orgId: res.data?.orgId, token: res.data?.token, _id: res.data?._id})
                                    res.data.planAccess = planAccess
                                    dispatch({type: 'AUTHENTICATE', payload: res.data});
                                    sendData('hrms|request|masterData|read', {user: res?.data?._id});
                                    sendData('hrms|master|notifications|count', {userId: res?.data?._id});
                                } else {
                                    dispatch({type: 'SET_ERROR', payload: {description: ERROR.authenticate, type: 'full'}});
                                }
                            } else {
                                dispatch({type: 'SET_ERROR', payload: {description: ERROR.removeProductAccess, type: 'full'}});
                            }
                            break;
                        case 'workdiary|authresponse': {
                            dispatch({type: 'SET_WORK_DIARY_AUTH_RESPONSE', payload: res.data});
                            break;
                        }
                        case 'productPlanUpdate':
                        case 'productAccessUpdate': {
                            if (typeof res?.data?.hrms === 'boolean' && !res?.data?.hrms) {
                                dispatch({type: 'SET_ERROR', payload: {description: ERROR.removeProductAccess, type: 'full'}});
                                dispatch({type: 'PRODUCT_ACCESS_REMOVED', payload: res.data});
                            }
                            break;
                        }
                        case 'hrms|request|masterData|read': {
                            if(res?.data?.uac?.hrms) {
                                dispatch({type: 'GET_HRMS_MASTER_DATA', payload: res.data});
                                dispatch({type: 'GET_COUNTRY_STATUS', payload: CONSTANT?.COUNTRY_CODE})
                                dispatch({type: 'GET_LANGUAGE_STATUS', payload: CONSTANT?.LANGUAGES})
                                sendData('hrms|shift|read|list', {})
                                sendData('master|paymentbar|content|get', {orgId: window.location.pathname.split('/')[1]});
                            } else {
                                dispatch({type: 'SET_ERROR', payload: {description: ERROR.accessLevelNotAssign , type: 'full'}});
                            }
                            break;
                        }
                        case 'hrms|india|state|list':
                            dispatch({type: 'SET_INDIA_STATE', payload: res?.data?.list})
                            break;
                        case 'master|paymentbar|content|get': {
                            dispatch({type: 'GET_PAYMENT_BAR_DATA', payload: res.data});
                            break;
                        }
                        case 'hrms|onboarding|masterData|read': {
                            dispatch({type: 'GET_HRMS_MASTER_DATA', payload: res.data});
                            break;
                        }
                        case 'hrms|request|masterData|update':
                            dispatch({type: 'UPDATE_HRMS_MASTER_DATA', payload: res.data});
                            break;
                        case 'hrms|timeSheet|getCurrentTiming':
                            dispatch({type: 'GET_CURRENT_TIMING', payload: res.data});
                            break;
                        case 'getGeneralSetting':
                        case 'hrms|master|workDiaryUsers|reload':
                        case 'hrms|master|settings|update': {
                            dispatch({type: 'UPDATE_MASTER_SETTINGS', payload: res.data});
                            break;
                        }
                        case 'updateMasterData': {
                            dispatch({type: 'UPDATE_MASTER_DATA', payload: res.data});
                            break;
                        }
                        case 'hrms|master|employee|filter':
                        case 'hrms|master|employee|group':
                        case 'hrms|master|probation|group':
                        case 'hrms|reports|probation|list':
                        case 'hrms|master|resignation|filter':
                        case 'hrms|reports|agreement|list':
                            dispatch({type: 'GET_EMPLOYEE_DATA', payload: res.data});
                            break;
                        case 'hrms|employee|read':
                            if (res.data) dispatch({type: 'GET_PERTICULAR_EMPLOYEE', payload: res.data});
                            break;
                        case 'hrms|user|employee|read':
                            if (res.data) dispatch({type: 'GET_PERTICULAR_EMPLOYEE', payload: res.data});
                            break;
                        case 'hrms|employee|update':
                            if (!res.data.otp) {
                                sendData('hrms|employee|read', {user: res?.data?.user || res?.data?._id})
                                if (res?.data?.socketId === socket?.id) {
                                    showToastSuccess(res?.data?.isRequest ? 'Request Added Successfully.' : 'Updated Successfully.');
                                }
                            }
                            break;
                        case 'getWorkspaceList':
                            dispatch({type: 'SET_WORKSPACE_LIST', payload: res.data.list});
                            break;
                        case 'getLatestVersion': {
                            dispatch({type: 'SET_LATEST_VERSION', payload: res.data, initial: true});
                            break;
                        }
                        case 'updateAppVersion':
                            dispatch({type: 'SET_LATEST_VERSION', payload: res.data});
                            break;
                        case 'readProductVideo':
                            dispatch({type: 'SET_PRODUCT_VIDEO', payload: res.data});
                            break;
                        case 'clearCache':
                            dispatch({type: 'CLEAR_CACHE_POPUP', payload: res.data});
                            break;
                        case 'hrms|master|inbox|count': {
                            dispatch({type: 'SET_INBOX_COUNT', payload: res?.data})
                            break;
                        }
                        case 'hrms|master|uac|reload':
                            dispatch({type: 'SET_UAC_UPDATE', payload: res.data});
                            break;
                        case 'hrms|master|logo|read':
                            dispatch({type: 'COMPANY_LOGO', payload: res.data});
                            break
                        case 'hrms|shift|create':
                        case 'hrms|shift|update':
                            sendData('hrms|shift|read|list', {}, true)
                            break
                        case 'hrms|shift|read|list':
                            dispatch({type: 'SET_SHIFT_LIST', payload: {shiftList: res?.data}})
                            break
                        case 'hrms|attendance|break|user|fetchBreak':
                            dispatch({type: 'SET_BREAK_LIST', payload: res?.data})
                            break
                        case 'hrms|master|location|create': {
                            dispatch({type: 'LOCATION_INFO', payload: {...res.data, action: 'add'}});
                            break;
                        }
                        case 'hrms|master|location|active': {
                            dispatch({type: 'LOCATION_INFO', payload: {...res.data, action: 'active'}});
                            break;
                        }
                        case 'hrms|master|location|update': {
                            dispatch({type: 'LOCATION_INFO', payload: {...res.data, action: 'update'}})
                            break;
                        }
                        case 'hrms|master|location|delete': {
                            dispatch({type: 'LOCATION_INFO', payload: {...res.data, action: 'remove'}})
                            break
                        }
                        case 'hrms|master|locationBillingType|create': {
                            dispatch({type: 'LOCATION_BILLING_TYPE_INFO', payload: {...res.data, action: 'add'}});
                            break;
                        }
                        case 'hrms|master|locationBillingType|update': {
                            dispatch({type: 'LOCATION_BILLING_TYPE_INFO', payload: {...res.data, action: 'update'}})
                            break;
                        }
                        case 'hrms|master|locationBillingType|delete': {
                            dispatch({type: 'LOCATION_BILLING_TYPE_INFO', payload: {...res.data, action: 'remove'}})
                            break
                        }
                        case 'hrms|master|subLocations|create': {
                            dispatch({type: 'SUB_LOCATION_REPORT', payload: {...res.data, action: 'add'}});
                            break;
                        }
                        case 'hrms|master|subLocations|update': {
                            dispatch({type: 'SUB_LOCATION_REPORT', payload: {...res.data, action: 'update'}})
                            break;
                        }
                        case 'hrms|master|subLocation|delete': {
                            dispatch({type: 'SUB_LOCATION_REPORT', payload: {...res.data, action: 'remove'}})
                            break
                        }
                        case 'hrms|master|degree|create': {
                            dispatch({type: 'DEGREE_INFO', payload: {...res.data, action: 'add'}});
                            break;
                        }
                        case 'hrms|master|degree|update': {
                            dispatch({type: 'DEGREE_INFO', payload: {...res.data, action: 'update'}})
                            break;
                        }
                        case 'hrms|master|degree|delete': {
                            dispatch({type: 'DEGREE_INFO', payload: {...res.data, action: 'remove'}})
                            break
                        }
                        case 'hrms|master|category|create': {
                            dispatch({type: 'CATEGORY_INFO', payload: {...res.data, action: 'add'}});
                            break;
                        }
                        case 'hrms|master|category|update': {
                            dispatch({type: 'CATEGORY_INFO', payload: {...res.data, action: 'update'}})
                            break;
                        }
                        case 'hrms|master|category|delete': {
                            dispatch({type: 'CATEGORY_INFO', payload: {...res.data, action: 'remove'}})
                            break;
                        }
                        case 'hrms|master|employeeFiled|createEmployeeFields': {
                            dispatch({type: 'BUSINESS_INFO', payload: {...res.data, action: 'add'}});
                            break;
                        }
                        case 'hrms|master|employeeFiled|updateEmployeeFields': {
                            dispatch({type: 'BUSINESS_INFO', payload: {...res.data, action: 'update'}})
                            break;
                        }
                        case 'hrms|master|employeeFiled|deleteEmployeeFields': {
                            dispatch({type: 'BUSINESS_INFO', payload: {...res.data, action: 'remove'}})
                            break;
                        }
                        case 'hrms|master|department|create': {
                            dispatch({type: 'DEPARTMENT_INFO', payload: {...res.data, action: 'add'}});
                            break;
                        }
                        case 'hrms|master|department|update': {
                            dispatch({type: 'DEPARTMENT_INFO', payload: {...res.data, action: 'update'}})
                            break;
                        }
                        case 'hrms|master|department|delete': {
                            dispatch({type: 'DEPARTMENT_INFO', payload: {...res.data, action: 'remove'}})
                            break
                        }
                        case 'hrms|master|subdepartment|create': {
                            dispatch({type: 'SUB_DEPARTMENT_INFO', payload: {...res.data, action: 'add'}});
                            break;
                        }
                        case 'hrms|master|subdepartment|update': {
                            dispatch({type: 'SUB_DEPARTMENT_INFO', payload: {...res.data, action: 'update'}})
                            break;
                        }
                        case 'hrms|master|subdepartment|delete': {
                            dispatch({type: 'SUB_DEPARTMENT_INFO', payload: {...res.data, action: 'remove'}})
                            break
                        }
                        case 'hrms|master|employeeStatus|create': {
                            dispatch({type: 'EMPLOYEE_STATUS_INFO', payload: {...res.data, action: 'add'}});
                            break;
                        }
                        case 'hrms|master|employeeStatus|update': {
                            dispatch({type: 'EMPLOYEE_STATUS_INFO', payload: {...res.data, action: 'update'}})
                            break;
                        }
                        case 'hrms|master|employeeStatus|delete': {
                            dispatch({type: 'EMPLOYEE_STATUS_INFO', payload: {...res.data, action: 'remove'}})
                            break
                        }
                        case 'hrms|master|relationship|create': {
                            dispatch({type: 'FAMILY_INFO', payload: {...res.data, action: 'add'}});
                            break;
                        }
                        case 'hrms|master|relationship|update': {
                            dispatch({type: 'FAMILY_INFO', payload: {...res.data, action: 'update'}})
                            break;
                        }
                        case 'hrms|master|relationship|delete': {
                            dispatch({type: 'FAMILY_INFO', payload: {...res.data, action: 'remove'}})
                            break
                        }
                        case 'hrms|master|idProof|create': {
                            dispatch({type: 'ID_PROOF_INFO', payload: {...res.data, action: 'add'}});
                            break;
                        }
                        case 'hrms|master|idProof|update': {
                            dispatch({type: 'ID_PROOF_INFO', payload: {...res.data, action: 'update'}})
                            break;
                        }
                        case 'hrms|master|idProof|delete': {
                            dispatch({type: 'ID_PROOF_INFO', payload: {...res.data, action: 'remove'}})
                            break
                        }
                        case 'hrms|master|jobTitle|create': {
                            dispatch({type: 'JOB_TITLE_INFO', payload: {...res.data, action: 'add'}});
                            break;
                        }
                        case 'hrms|master|jobTitle|update': {
                            dispatch({type: 'JOB_TITLE_INFO', payload: {...res.data, action: 'update'}})
                            break;
                        }
                        case 'hrms|master|jobTitle|delete': {
                            dispatch({type: 'JOB_TITLE_INFO', payload: {...res.data, action: 'remove'}})
                            break
                        }
                        case 'hrms|master|activity|create': {
                            dispatch({type: 'LOCATION_ACTIVITY', payload: {...res.data, action: 'add'}});
                            break;
                        }
                        case 'hrms|master|activity|update': {
                            dispatch({type: 'LOCATION_ACTIVITY', payload: {...res.data, action: 'update'}})
                            break;
                        }
                        case 'hrms|master|activity|delete': {
                            dispatch({type: 'LOCATION_ACTIVITY', payload: {...res.data, action: 'remove'}})
                            break;
                        }
                        case 'hrms|master|organizationStructure|List': {
                            dispatch({type: 'GET_ORG_STRUCTURE', payload: res?.data});
                            break;
                        }
                        case 'hrms|master|notifications|count': {
                            dispatch({type: 'NOTIFICATION_COUNT', payload: res?.data?.count});
                            break
                        }
                        case 'hrms|master|notifications|countUpdate': {
                            dispatch({type: 'NOTIFICATION_COUNT', payload: res?.data?.unReadCount});
                            if (res?.data?.notification) {
                                dispatch({type: 'UPDATE_GLOBAL_NOTIFICATION_LIST', payload: res?.data?.notification});
                            }
                            break
                        }
                        case 'hrms|master|notifications|read':
                            if (res?.data?.isReadAll) {
                                dispatch({type: 'READ_GLOBAL_NOTIFICATION_LIST', payload: res?.data});
                            }
                            break;
                        case 'hrms|pms|activeTimer|start': {
                            dispatch({type: 'SET_MY_TIMER', payload: res});
                            break;
                        }
                        case 'stopTimeTracker': {
                            dispatch({type: 'SET_MY_TIMER', payload: res});
                            break;
                        }
                        case 'removeTimeTracker': {
                            dispatch({type: 'SET_MY_TIMER', payload: res});
                            break;
                        }
                        case 'hrms|master|get': {
                            dispatch({type: 'GET_MASTER_INFO_UPDATE', payload: res.data})
                            break;
                        }
                        case 'hrms|dropList|get': {
                            if (res?.data?.listType === 4 && res?.data?.rows?.length !== 0) dispatch({type: 'GET_MASTER_INFO_UPDATE', payload: {users: res.data?.rows ?? []}})
                            break;
                        }
                        case 'hrms|attendance|timeSheet' : {
                            if (res?.data?.responseType === HRMS_STATUS?.TIME_SHEET_REQUEST_TYPE?.ADD) {
                                showToastSuccess(SUCCESS.addRequest)
                            } else if (res?.data?.responseType === HRMS_STATUS?.TIME_SHEET_REQUEST_TYPE?.UPDATE) {
                                showToastSuccess(SUCCESS.updateRequest)
                            }
                            break
                        }
                        case 'hrms|attendance|verification|update' : {
                            if (res?.data?.socketId === socket?.id) {
                                showToastSuccess(SUCCESS.verificationStatus)
                            }
                            break
                        }

                        // Leave Module
                        case 'hrms|leave|balance|read': {
                            dispatch({type: 'SET_USER_LEAVE_BALANCE', payload: res.data})
                            break;
                        }
                        case 'hrms|leave|balance|delete': {
                            dispatch({type: 'DELETE_USER_LEAVE_BALANCE', payload: res.data})
                            break;
                        }
                        case 'hrms|leave|application|upcoming' : {
                            dispatch({type: 'SET_USER_UPCOMING_LEAVE', payload: res.data})
                            break;
                        }
                        case 'hrms|leave|application|myHistory': {
                            dispatch({type: 'SET_MY_LEAVE_HISTORY', payload: res.data});
                            const findUser = new Set();
                            res?.data?.list?.map((item) => {
                                item?.multiApprovalInfo?.map((member) => {
                                    member?.assignUser?.map((au) => {
                                        if (au.uacID) findUser?.add(au.uacID)
                                    })
                                    if (member?.actionBy) findUser?.add(member?.actionBy)
                                })
                            })
                            if (findUser.size !== 0) dispatch({type: 'FIND_MASTER_DATA_LIST', payload: {findUserIdsList: [...findUser]}});
                            break;
                        }
                        case 'hrms|leaveBalance|adjustment|read': {
                            const findUser = new Set();
                            res.data?.list?.map((item) => {
                                if (item?.updatedBy) findUser?.add(item?.updatedBy)
                            })
                            if (findUser.size !== 0) dispatch({type: 'FIND_MASTER_DATA_LIST', payload: {findUserIdsList: [...findUser]}});
                            dispatch({type: 'SET_LEAVE_ADJUSTMENT', payload: res.data})
                            break;
                        }
                        case 'hrms|leave|holiday|upcoming': {
                            dispatch({type: 'SET_USER_UPCOMING_HOLIDAY', payload: res.data})
                            break;
                        }
                        case 'hrms|leave|type|list': {
                            dispatch({type: 'SET_LEAVE_TYPE', payload: res.data})
                            break;
                        }
                        case 'hrms|leave|type|read': {
                            dispatch({type: 'SET_LEAVE_POLICY_LIST', payload: res.data?.list})
                            break;
                        }
                        case 'hrms|leave|application|summary': {
                            dispatch({type: 'SET_LEAVE_APPLICATION_SUMMERY', payload: res.data})
                            break;
                        }
                        case 'hrms|leave|summary|update': {
                            dispatch({type: 'UPDATE_LEAVE_APPLICATION_SUMMERY', payload: res.data})
                            break;
                        }
                        case 'hrms|leave|application|employees': {
                            dispatch({type: 'SET_LEAVE_APPLICATIONS', payload: res.data})
                            break;
                        }
                        case 'hrms|leave|application|update':
                        case 'hrms|leave|application|updateStatus': {
                            dispatch({type: 'UPDATE_LEAVE_APPLICATIONS', payload: res.data})
                            break;
                        }
                        case 'hrms|leave|balance|employees': {
                            dispatch({type: 'SET_LEAVE_BALANCE', payload: res.data});
                            break;
                        }
                        case 'hrms|leave|balance|update': {
                            dispatch({type: 'UPDATE_LEAVE_BALANCE', payload: res.data})
                            break;
                        }
                        case 'hrms|master|geo|update': {
                            dispatch({type: 'GEO_UPDATE', payload: res.data})
                            break;
                        }
                        case 'hrms|helpDesk|ticket|layout|fetch': {
                            dispatch({type: 'SET_SAVE_LAYOUT_INFO', payload: res?.data});
                            break;
                        }
                        case ANNOUNCEMENT_API.alert: {
                            dispatch({type: 'SET_ANNOUNCEMENT', payload: res?.data});
                            break;
                        }
                        case 'hrms|documents|docx|preview': {
                            dispatch({type: 'OPEN_DOC_URL', payload: res?.data?.result});
                            break;
                        }
                        case 'hrms|employee|profileRequest|detail': {
                            dispatch({type: 'USER_REQUEST_DATA', payload: res?.data?.rows});
                            break;
                        }
                        case 'hrms|reports|attendance|breakReport' : {
                            dispatch({type: 'SET_BREAK_REPORT', payload: res?.data});
                            break;
                        }
                        case 'territoriesList':
                            dispatch({type: 'GET_TERRITORY_DATA', payload: {
                                    currencyList: res?.data?.currency?.map(c => ({
                                        symbol: c?.label,
                                        code: c?.obj?.code,
                                        country: c?.value,
                                        label: `${c?.value}-${c?.obj?.code}-${c?.label}`
                                    })) ?? []
                                }})
                            break
                        case 'getCompaniesList': {
                            let data = JSON.parse(JSON.stringify(res?.data?.getCompanyList))
                            let dataArr = []
                            data.map(e => {
                                dataArr.push({...e, label: e?.name, value: e?._id})
                            })
                            dispatch({type: 'SET_CLIENT_LIST', payload: dataArr})
                            break;
                        }
                        case 'hrms|master|platform|access|update': {
                            dispatch({type: 'UPDATE_PLATFORM_ACCESS', payload: res?.data?.companyInfo});
                            break;
                        }
                        default:
                            return true;
                    }
                }
            }
        }
    });

    socket.on("disconnect", (res) => {
        socket.isAuthenticated = false
        dispatch({type: 'SOCKET_CONNECTION', payload: socket.id});
        // dispatch({type: 'AUTHENTICATE', payload: false});
    });
};

export const responseHandler = (response) => {
    let res;
    if (typeof response === 'string') res = Decryption(response)
    else res = response
    return res;
}

export const onLogout = async() => {
    try {
        await deleteEventDB();
        // proceed with logout
        } catch (error) {
        console.error('Error deleting event database:', error);
        // handle error or proceed with logout anyway
    }
    sendMessageRNW(0, {})
    const device_token = ['fcm_chat', 'fcm_hrms', 'fcm_pms', 'fcm_recruit', 'fcm_asset'].reduce((tokens, cookie) => {
        const cookieValue = getCookie(cookie);
        if (cookieValue) tokens.push(cookieValue);
        return tokens;
    }, []);

    sendData('logout', { device_token, platform: detectDevice(true)});
    const cookiesToErase = ['ubs_token', 'fcm_chat', 'fcm_hrms', 'fcm_pms', 'fcm_recruit', 'fcm_asset'];
    localStorage.clear();
    deleteAllCookies();
    cookiesToErase.forEach(eraseCookie);
    createCookie('ubsHRMSModule', 'hrms');

    setTimeout(() => {
        window.location.href = isInApp() ? `${process.env.REACT_APP_ACCOUNT_MODULE_URL}/?platform=app` : process.env.REACT_APP_ACCOUNT_MODULE_URL;
    }, 500);
};

export {socket, api};
